var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-select",
        {
          staticClass: "date-options gtm-date-range-selector",
          class: { "with-picker": _vm.showPicker },
          attrs: { size: _vm.size },
          model: {
            value: _vm.dateRange,
            callback: function ($$v) {
              _vm.dateRange = $$v
            },
            expression: "dateRange",
          },
        },
        _vm._l(_vm.dateOptions, function (option, index) {
          return _c(
            "option",
            { key: index, domProps: { value: option.value } },
            [_vm._v(" " + _vm._s(option.label) + " ")]
          )
        }),
        0
      ),
      _vm.showPicker
        ? _c("date-range-picker", {
            attrs: {
              start: _vm.startDate,
              end: _vm.endDate,
              picker: _vm.picker,
              size: _vm.size,
            },
            on: { apply: _vm.setReportDate },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }